









import { Vue, Component, Prop } from "vue-property-decorator";
// import UserSelect from "../../../pt/components/UserSelect/index.vue";
import UserSelect from "../../../pt/components/LsSelectUser/index.vue";

@Component({
  name: "UserSelectComponentNew",
  components: { UserSelect }
})
export default class UserSelectComponent extends Vue {
  @Prop({ required: true })
  value!: string;

  @Prop({ required: true })
  text!: string;

  @Prop({ required: true, default: false })
  show!: boolean;

  @Prop({ default: false })
  multiEnable!: boolean;

  @Prop({ default: "" })
  orgId!: string;

  get showPltSelect() {
    return this.show;
  }

  set showPltSelect(n) {
    this.$emit("update:show", n);
  }

  get user() {
    // console.log(333, this.value);

    return this.value ? this.value.split(",") : [];
  }

  selectModalEvt(data: any) {
    this.$emit("update:value", data.valueText);
    this.$emit("update:text", data.text);
    this.$emit("confirm", data);
  }
}
